import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

import { Heading, RichText } from '@swordhealth/ui-corporate';
import { formattedTitle } from '@/utils/formatted-title';

const Title = ({ title, referralUser, list = [] }) => {
  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    if (list.length > 1 && !referralUser) {
      const timeoutId = setTimeout(() => {
        setMessageIndex((prev) => (prev + 1) % list.length);
      }, 3000);

      return () => clearTimeout(timeoutId);
    }
  }, [list.length, messageIndex, referralUser]);

  return (
    <TitleWrapper $isReferral={referralUser}>
      <Heading as="h1" size="3xl" id="platform-hero-title">
        {referralUser ? (
          <RichText>{formattedTitle({ title, referralUser })}</RichText>
        ) : (
          <>
            {title}
            {list.length > 0 && <strong> {list[messageIndex]?.sentence}</strong>}
          </>
        )}
      </Heading>
    </TitleWrapper>
  );
};

export default React.memo(Title);

const TitleWrapper = styled.div`
  max-width: ${(props) => props.$isReferral && '720px'};
  h1 {
    text-wrap: ${(props) => !props.$isReferral && 'unset'};

    strong {
      @media (min-width: 390px) {
        display: block;
      }
    }
  }
  @media (min-width: ${(props) => props.theme.breakpoints.min_md}px) {
    h1 {
      display: inline-grid;
    }
  }
`;
